export default __webpack_public_path__ + "static/deep-habits-friendship-iPhone-11-Pro-2021-04-12-2527083ccb25b9c371972fdd706ee171.png";